import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthLayout } from "../../../components/layouts/AuthLayout";
import { SigninForm } from "../../../components/features/authentication/SigninForm";
import { PageProps } from "@sdflc/react-router-pages";

// Props that @sdflc/react-router-pages passes to page components
export interface SigninPageProps extends PageProps {}

export const SigninPage: React.FC<SigninPageProps> = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleSigninSuccess = (userData: any) => {
    console.log("User signed in successfully:", userData);

    let returnUrl = searchParams.get("returnUrl");

    if (!returnUrl) {
      returnUrl = "/";
    }

    navigate(decodeURI(returnUrl));
  };

  const handleNavigateToSignup = () => {
    navigate("/account/signup");
  };

  const handleNavigateToForgotPassword = () => {
    navigate("/account/forgot-password");
  };

  return (
    <AuthLayout title="Sign In" subtitle="Welcome back to VenueBoards" showLogo>
      <SigninForm
        onSigninSuccess={handleSigninSuccess}
        onNavigateToSignup={handleNavigateToSignup}
        onNavigateToForgotPassword={handleNavigateToForgotPassword}
      />
    </AuthLayout>
  );
};
